export default __webpack_public_path__ + "047157551b5b21b6343b82395ce16867.png";